<template>
    <div>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <v-card color="transparent" flat>
            <v-card-text class="px-0">
                <v-stepper alt-labels v-model="step" class="elevation-0" style="background-color:transparent;">
                    <v-stepper-header class="elevation-0">
                        <v-spacer></v-spacer>
                        <v-stepper-step step="1">
                            {{ $t('geneticsAndBreeding.animalSelection') }}
                        </v-stepper-step>
                        <v-divider ></v-divider>
                        <v-stepper-step step="2">
                            {{ $t('geneticsAndBreeding.dataSubmission') }}
                        </v-stepper-step>
                        <v-spacer></v-spacer>
                    </v-stepper-header>
                    <v-stepper-items>
                    <v-stepper-content step="1">
                        <AnimalList @animal-selected="animalSelected"/>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <!-- <GeneticAnimalForm @form-updated="formUpdated" v-if="step==2" :animal="selectedAnimal" /> -->
                        
                        <EditGeneticAnimalForm v-if="animalData" @form-updated="formUpdated" :action="'create'" :animal="animalData"/>

                    </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
                
            </v-card-text>
        </v-card>
        <!-- <DataLostWarning
            :dialogI="dataLossWarning"
            v-if="dataLossWarning"
            @closeDialog="closeWarningMessage"
            @saveData="closeWarningMessage"  
        ></DataLostWarning> -->
    </div>
</template>

<script>
import AnimalList from "./AnimalList.vue"
//import GeneticAnimalForm from "./EPDForm.vue" //"./GeneticAnimalForm.vue"
import EditGeneticAnimalForm from "./EPDFormV2.vue" //"./EditGeneticAnimalForm.vue"
import moment from 'moment';
import {
  animalCategories,
  breeds,
  classes,
  farms,
  farmTypes,
  generalInfo,
  species,
  speciesTypes,
  getDropDownDataAnimalIdentification,
  getDropDownDataBirthOrigin,
  getWeightUnit
} from "@/graphql/Animals.gql";

export default {
    apollo: {
        animalToUpdate: {
            query: generalInfo,
            variables() {
                return { id: parseInt(this.currentAnimal) }
            },
            fetchPolicy: 'network-only',
            update: data => data.generalInformation,
            // Disable the query
            skip() {
                return this.skipQuery
            },
            result({ data }) {
                const animal = data.generalInformation;

                if (animal.removalInformation == null) {
                    animal.removalInformation = {};
                }
            
                if (animal.animalIdentification == null) {
                    animal.animalIdentification = {};
                }
            
                if (animal.additionalInformation == null) {
                    animal.additionalInformation = {};
                }

                if (animal.birthOrigin == null) {
                    animal.birthOrigin = {};
                }

                if (animal.parentageInformation == null) {
                    animal.parentageInformation = {};
                }

                if (animal.ownerBreedAssociation == null) {
                    animal.ownerBreedAssociation = {};
                }

                if(animal.breedId == null) {
                    animal.breedId = '9999'
                }
                
                if (animal.removalInformation && !animal.removalInformation.dateOfRemoval) {
                    animal.removalInformation.dateOfRemoval = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                        .toISOString()
                        .substr(0, 10);
                }

                if (animal.animalIdentification.dateOfRegistration) {
                    animal.animalIdentification.dateOfRegistration = moment(animal.animalIdentification.dateOfRegistration).format('YYYY-MM-DD');
                }

                if (animal.removalInformation.processingDate) {
                    animal.removalInformation.processingDate = moment(animal.removalInformation.processingDate).format('YYYY-MM-DD');
                }

                animal.birthOrigin.dateOfBirth = animal.birthOrigin.dateOfBirth ? moment(animal.birthOrigin.dateOfBirth).format('YYYY-MM-DD') : null;
                animal.removalInformation.dateOfRemoval = moment(animal.removalInformation.dateOfRemoval).format('YYYY-MM-DD');
                if(animal.animalIdentification.identificationMethods && (Array.isArray(animal.animalIdentification.identificationMethods ))) {
                    animal.animalIdentification.identificationMethods = animal.animalIdentification.identificationMethods.map(el => {
                        el.id = el.identification_method_id
                        return el
                    })
                } else if(animal.animalIdentification.identificationMethods ) {
                    animal.animalIdentification.identificationMethods  = []
                } else {
                    animal.animalIdentification.identificationMethods = []
                }

               // let t = Object.assign({}, animal); 
                ///let animalDup = {...animal};
               /// animal.animal_id = animalDup.id;

                let animalDup = JSON.parse(JSON.stringify(animal));
                animal.animal_id = animalDup.id;
                //animal.animal_id = animal.id;
                //Object.assign(animal, { animal_id: animal.id });

                const animalIdString = animal.id.toString();
                let animalIdWithPad = animalIdString.padStart(7, '0');
                animalIdWithPad = "ANI" + animalIdWithPad;
                //animal.id = animalIdWithPad;
                animal.animal_number = animalIdWithPad;

                animal.name = animal.animalIdentification?.livestockName
                animal.dob = animal.birthOrigin?.dateOfBirth
                animal.uniqueIdentifier = animal.animalIdentification?.id
                animal.conceptionMethod = animal.birthOrigin?.conceptionMethod?.name

                animal.sireId =  animal.parentageInformation.sireId
                animal.damId =  animal.parentageInformation.damId

                animal.registrationNumber =  animal.animalIdentification?.govRegistrationNo;
                animal.registrationDate =  animal.animalIdentification?.dateOfRegistration;
            

                animal.weightUnit = this.weightUnit;
                this.animalData = animal;
            }
        },

        getWeightUnit: {
            query:getWeightUnit,
            variables() {
                return { userId: parseInt(this.$store.getters.getUser.userDetail.id) }
            },
            result(data) {
                console.log(data.data.getWeightUnit.unit,"data.data.getWeightUnit.unit")
                this.weightUnit = data.data.getWeightUnit.unit
            }
        },
        animalCategories: {
            query: animalCategories,
        },
        breeds: {
            query: breeds,
        },
        classes: {
            query: classes,
        },
        farms: {
            query: farms
        },
        farmTypes: {
            query: farmTypes,
        },
        species: {
            query: species,
        },
        speciesTypes: {
            query: speciesTypes,
        },
        getDropDownDataAnimalIdentification: {
            query: getDropDownDataAnimalIdentification,
        },
        getDropDownDataBirthOrigin: {
            query: getDropDownDataBirthOrigin,
        },
    },
    components: {
        AnimalList,
        //GeneticAnimalForm,
        EditGeneticAnimalForm
    },
    beforeRouteLeave(to, from, next) {
		if(this.formChanged) {
			this.promptToRoute = to;
			this.dataLossWarning = true;
			return
		}else{
            next();
        }
	},
    data() {
        return {
            weightUnit:null,
            animalData:null,
            skipQuery: true,
            currentAnimal:1,
            dataLossWarning: false,
            formChanged: false,
            promptToRoute: null,
            step: 1,
            selectedAnimal: null,
            breadcrumbs: [
                {
                    text: this.$t('dashboard'),
                    disabled: false,
                    to: "/",
                },
                {
                    text: this.$t('geneticsAndBreeding.geneticsAndBreeding'),
                    disabled: true,
                    to: { name: "Genetics" },
                },
            ],
        }
    },
    methods:  {
        formUpdated(st) {
            console.log('ssss', st)
            this.formChanged = st;
        },
        closeWarningMessage(stay) {
            this.dataLossWarning = false;
            if(!stay) {
                this.formChanged = false;
                this.$router.push(this.promptToRoute)
            }
        },
        async animalSelected(animal) {
            this.$apollo.queries.animalToUpdate.skip = false
            this.currentAnimal = Number(animal[0].id);
            this.$apollo.queries.animalToUpdate.refetch();
            this.step = 2
        }
    }
}
</script>
